// extracted by mini-css-extract-plugin
module.exports = {"input":"Input-styles_input__1266Q"};